import forEach from 'lodash.foreach';
import isUndefined from 'lodash.isundefined';
import isNull from 'lodash.isnull';

(function (algolia) {
  'use strict';

  var sort_order_base = '' + algolia.config.index_prefix + 'products';

  algolia.sortOrders = [{ name: sort_order_base, label: '' + algolia.translations.relevance }];

  forEach(algolia.config.sort_orders, function (sort_order) {
    if (!isUndefined(sort_order.asc) && !isNull(sort_order.asc) && (sort_order.asc.active === true || sort_order.asc.active === '1')) {
      algolia.sortOrders.push({
        name: sort_order_base + '_' + sort_order.key + '_asc',
        label: sort_order.asc.title
      });
    }
    if (!isUndefined(sort_order.desc) && !isNull(sort_order.desc) && (sort_order.desc.active === true || sort_order.desc.active === '1')) {
      algolia.sortOrders.push({
        name: sort_order_base + '_' + sort_order.key + '_desc',
        label: sort_order.desc.title
      });
    }
  });
})(algoliaShopify);